import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { handleChange, handleSubmit } from "../../controller/ReportController/CreateReportController";
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import HelpSiteService from "../../../SuperAdmin/Controller/Configuration/HelpSiteController";
import ModuleService from "../../../Setup/controller/ModuleController/ModuleController";
import ReportService from "../../controller/ReportController/ReportController";
import CompanyListService from "../../../SuperAdmin/Controller/Client/SACompanyListController";
function CreateIndustrySector({ currentReport, onClose, onSuccess }) {
    const { t } = useTranslation();

    const [formData, setFormData] = useState({
        ID: "0",
        ReportTitle: '',
        Link: '',
        Description: '',
        ModuleID: '0',
        ParamTypes: {},
        ListParams: {},
        ClientID: "0",
        ReportName: "",
        ReportType: "",
        IsDefault: "0"
    });
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const { theme, toggleTheme } = useContext(ThemeContext);
    const [formList, setFormList] = useState([]);
    const [companyList, setCompanies] = useState([]);
    const [paramKeys, setParamKeys] = useState([]);
    let accordTheme = "accordion-header-light";
    if (theme == "dark") {
        accordTheme = "accordion-header-dark";
    }
    useEffect(() => {
        setFormData(prev => ({ ...prev, ParamKeys: paramKeys }));
    }, [paramKeys]);
    useEffect(() => {
        fetchClients();
        fetchForms(formData.ClientID);
        if (currentReport) {
            const { keys, formattedUrl } = extractParamsFromLink(currentReport.Link);

            setFormData({
                ReportTitle: currentReport.ReportTitle,
                Link: formattedUrl,
                Description: currentReport.Description,
                ModuleID: currentReport.ModuleID,
                ParamTypes: currentReport.ParamTypes || {},
                ListParams: currentReport.ListParams || {},
                ClientID: currentReport.ClientID || "0",
                ReportName: currentReport.ReportName,
                ReportType: currentReport.ReportType,
                IsDefault: currentReport.IsDefault,

            });

            setParamKeys(keys);
            fetchInputParameters(currentReport.ID, keys);

        } else {
            setFormData({
                ReportTitle: '', Link: '', Description: '', ModuleID: '0',
                ReportName: "",
                ReportType: "", IsDefault: "0"
            });
        }
    }, [currentReport]);
    useEffect(() => {
        if (formData.ClientID && formData.ClientID !== "0") {
            fetchForms(formData.ClientID);
        } else {
            setFormList([]); // Clear module list if no client selected
        }
    }, [formData.ClientID]);
    const handleFieldChange = (event) => {
        const { name, value } = event.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };
    const fetchForms = async (ClientID) => {
        try {
            const redirectCallback = () => navigate('/');
            const list = await ModuleService.GetAllModulesWithClient(redirectCallback, 'en', ClientID);
            setFormList(list || []);
        } catch (error) {
            console.error('Error fetching Modules:', error);
        }
    };
    const fetchClients = async () => {
        try {
            const CompanyList = await CompanyListService.GetAllCompanies(() => navigate('/'));
            setCompanies(CompanyList);
        } catch (error) {
            console.error('Error fetching clients:', error);
        }
    };

    const handleFormSubmit = async (event) => {
        event.preventDefault(); // Prevent default form submission
        if (currentReport) {
            formData.ID = currentReport.ID;
        } else {
            formData.ID = 0;
        }
        const redirectCallback = () => {
            navigate('/'); // Redirect to the login page
        };
        const redirectUserList = () => {
            navigate('/AdministrationSetting?saved=true');
        };
        const response = await handleSubmit(event, formData, setFormData, setErrors);
        if (response && response.data.message === "Data saved successfully") {
            onSuccess();
        }
    };
    const handleLinkBlur = () => {
        const { keys, formattedUrl } = extractParamsFromLink(formData.Link);
        setFormData(prev => ({ ...prev, Link: formattedUrl }));
        setParamKeys(keys);
    };
    const extractParamsFromLink = (rawLink) => {
        try {
            const url = new URL(rawLink);
            const params = new URLSearchParams(url.search);
            const keys = Array.from(params.keys());

            // Ensure placeholders are in {param} format
            const formattedParams = keys.map(key => `${key}={${key}}`).join("&");
            const formattedUrl = `${url.origin}${url.pathname}?${formattedParams}`;

            return { keys, formattedUrl };
        } catch (error) {
            console.error('Invalid URL:', error);
            return { keys: [], formattedUrl: rawLink };
        }
    };
    const fetchInputParameters = async (ReportID, urlKeys = []) => {
        try {
            const reportParams = await ReportService.GetInputParameters(ReportID);

            if (reportParams && reportParams.length > 0) {

                const paramTypesMap = {};
                const listParamsMap = {};

                reportParams.forEach(param => {
                    let type = param.Type;

                    if (param.options) {
                        type = "list";
                    }

                    paramTypesMap[param.Name] = type;

                    listParamsMap[param.Name] = {
                        display: param.DisplayName || "",
                        table: type === "list" ? (param.options || "") : "",
                        key: type === "list" ? (param.options_value_field || "") : "",
                        value: type === "list" ? (param.options_label_field || "") : "",
                        orderBy: type === "list" ? (param.orderBy || "") : ""
                    };
                });

                // Keep URL order
                const orderedKeys =
                    urlKeys.length > 0
                        ? urlKeys.filter(k => paramTypesMap.hasOwnProperty(k))
                        : reportParams.map(p => p.Name);

                setParamKeys(orderedKeys);

                setFormData(prev => ({
                    ...prev,
                    ParamTypes: paramTypesMap,
                    ListParams: listParamsMap
                }));
            }

        } catch (error) {
            console.error(error);
        }
    };
    const handleRemoveParamKey = (keyToDelete) => {

        const updatedKeys = paramKeys.filter((k) => k !== keyToDelete);

        const updatedTypes = { ...formData.ParamTypes };
        const updatedListParams = { ...formData.ListParams };

        delete updatedTypes[keyToDelete];
        delete updatedListParams[keyToDelete];

        setParamKeys(updatedKeys);
        setFormData({
            ...formData,
            ParamTypes: updatedTypes,
            ListParams: updatedListParams,
        });
    };

    return (
        <div>
            <form onSubmit={handleFormSubmit}>

                <div className="modal fade reportModal show d-block" id="reportModal" tabIndex="-1" aria-labelledby="reportModalLabel" aria-hidden="true" data-backdrop="static">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className={`modal-header ${accordTheme}`}>
                                <h5 className="modal-title" id="largeModalLabel">{currentReport ? "Edit Report" : "Add Report"}</h5>
                                <button type="button" className="btn-close" data-dismiss="modal" aria-label="Close" onClick={onClose}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">

                                <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px", "marginTop": "10px" }}>
                                    <label htmlFor="inputText" className="col-sm-2 col-form-label">Report Title:</label>
                                    <div className="col-sm-6">
                                        <input type="text" className="form-control" name="ReportTitle" value={formData.ReportTitle} onChange={handleFieldChange} />
                                        {errors.ReportTitle && <div style={{ color: 'red' }}>{errors.ReportTitle}</div>}
                                    </div>

                                </div>
                                <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px", "marginTop": "10px" }}>
                                    <label htmlFor="inputText" className="col-sm-2 col-form-label">Description:</label>
                                    <div className="col-sm-6">
                                        <input type="text" className="form-control" name="Description" value={formData.Description} onChange={handleFieldChange} />
                                        {errors.Description && <div style={{ color: 'red' }}>{errors.Description}</div>}
                                    </div>

                                </div>
                                <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px", "marginTop": "10px" }}>
                                    <label htmlFor="inputText" className="col-sm-2 col-form-label">Report Name:</label>
                                    <div className="col-sm-6">
                                        <input type="text" className="form-control" name="ReportName" value={formData.ReportName} onChange={handleFieldChange} />
                                        {errors.ReportName && <div style={{ color: 'red' }}>{errors.ReportName}</div>}
                                    </div>

                                </div>
                                <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px", "marginTop": "10px" }}>
                                    <label htmlFor="inputText" className="col-sm-2 col-form-label">Link:</label>
                                    <div className="col-sm-6">
                                        <input type="text" className="form-control" name="Link" value={formData.Link} onChange={handleFieldChange} onBlur={handleLinkBlur} />
                                        {errors.Link && <div style={{ color: 'red' }}>{errors.Link}</div>}
                                    </div>

                                </div>
                                <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px", "marginTop": "10px" }}>
                                    <label htmlFor="inputText" className="col-sm-2 col-form-label">Select Company:</label>
                                    <div className="col-sm-6">
                                        <select name="ClientID" className="form-control" onChange={handleFieldChange} value={formData.ClientID}>
                                            <option value="0">All Companies</option>
                                            {companyList.map((company) => (
                                                <option key={company.CoSetupID} value={company.CoSetupID}>
                                                    {company.CompanyName}
                                                </option>
                                            ))}
                                        </select>
                                        {errors.ClientID && <div style={{ color: 'red' }}>{errors.ClientID}</div>}
                                    </div>

                                </div>
                                <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px", "marginTop": "10px" }}>
                                    <label htmlFor="inputText" className="col-sm-2 col-form-label">Select Module:</label>
                                    <div className="col-sm-6">
                                        <select name="ModuleID" className="form-control" onChange={handleFieldChange} value={formData.ModuleID}>
                                            <option value="0">Select Module</option>
                                            {formList.map((form) => (
                                                <option key={form.PK_SearchModule_ID} value={form.PK_SearchModule_ID}>
                                                    {form.vc_ModuleName}
                                                </option>
                                            ))}
                                        </select>
                                        {errors.ModuleID && <div style={{ color: 'red' }}>{errors.ModuleID}</div>}
                                    </div>


                                </div>
                                <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px", "marginTop": "10px" }}>
                                    <label htmlFor="inputText" className="col-sm-2 col-form-label">Is Default:</label>
                                    <div className="col-sm-6">
                                        <select name="IsDefault" className="form-control" onChange={handleFieldChange} value={formData.IsDefault}>
                                            <option value="0">No</option>
                                            <option value="1">Yes</option>
                                        </select>
                                        {errors.IsDefault && <div style={{ color: 'red' }}>{errors.IsDefault}</div>}
                                    </div>
                                </div>

                                {paramKeys.length > 0 && (
                                    <div className="row mb-3" style={{ marginLeft: "5px", marginTop: "10px" }}>
                                        <label className="col-sm-2 col-form-label">URL Params:</label>
                                        <div className="col-sm-10">
                                            <table className="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th>Parameter</th>
                                                        <th>Type</th>
                                                        <th>Table</th>
                                                        <th>Key</th>
                                                        <th>Value</th>
                                                        <th>Display Name</th>
                                                        <th>Order By</th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {paramKeys.map((paramKey) => (
                                                        <tr key={paramKey}> {/* ✅ stable key */}
                                                            <td>
                                                                <input className="form-control" value={paramKey} readOnly />
                                                            </td>

                                                            <td>
                                                                <select
                                                                    className="form-control"
                                                                    value={formData?.ParamTypes?.[paramKey] || ""}
                                                                    onChange={(e) => {
                                                                        const updated = { ...(formData.ParamTypes || {}) };
                                                                        updated[paramKey] = e.target.value;
                                                                        setFormData({ ...formData, ParamTypes: updated });
                                                                    }}
                                                                >
                                                                    <option value="">Select</option>
                                                                    <option value="string">Text</option>
                                                                    <option value="number">Number</option>
                                                                    <option value="date">Date</option>
                                                                    <option value="list">List</option>
                                                                </select>
                                                            </td>

                                                            {formData?.ParamTypes?.[paramKey] === "list" ? (
                                                                <>
                                                                    <td>
                                                                        <input
                                                                            className="form-control"
                                                                            value={formData?.ListParams?.[paramKey]?.table || ""}
                                                                            onChange={(e) => {
                                                                                const list = { ...(formData.ListParams || {}) };
                                                                                list[paramKey] = {
                                                                                    ...(list[paramKey] || {}),
                                                                                    table: e.target.value
                                                                                };
                                                                                setFormData({ ...formData, ListParams: list });
                                                                            }}
                                                                        />
                                                                    </td>

                                                                    <td>
                                                                        <input
                                                                            className="form-control"
                                                                            value={formData?.ListParams?.[paramKey]?.key || ""}
                                                                            onChange={(e) => {
                                                                                const list = { ...(formData.ListParams || {}) };
                                                                                list[paramKey] = {
                                                                                    ...(list[paramKey] || {}),
                                                                                    key: e.target.value
                                                                                };
                                                                                setFormData({ ...formData, ListParams: list });
                                                                            }}
                                                                        />
                                                                    </td>

                                                                    <td>
                                                                        <input
                                                                            className="form-control"
                                                                            value={formData?.ListParams?.[paramKey]?.value || ""}
                                                                            onChange={(e) => {
                                                                                const list = { ...(formData.ListParams || {}) };
                                                                                list[paramKey] = {
                                                                                    ...(list[paramKey] || {}),
                                                                                    value: e.target.value
                                                                                };
                                                                                setFormData({ ...formData, ListParams: list });
                                                                            }}
                                                                        />
                                                                    </td>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                </>
                                                            )}

                                                            {/* Display Name - Always Visible */}
                                                            <td>
                                                                <input
                                                                    className="form-control"
                                                                    value={formData?.ListParams?.[paramKey]?.display || ""}
                                                                    onChange={(e) => {
                                                                        const list = { ...(formData.ListParams || {}) };
                                                                        list[paramKey] = {
                                                                            ...(list[paramKey] || {}),
                                                                            display: e.target.value
                                                                        };
                                                                        setFormData({ ...formData, ListParams: list });
                                                                    }}
                                                                />
                                                            </td>

                                                            {/* Order By only for List */}
                                                            {formData?.ParamTypes?.[paramKey] === "list" ? (
                                                                <td>
                                                                    <input
                                                                        className="form-control"
                                                                        value={formData?.ListParams?.[paramKey]?.orderBy || ""}
                                                                        onChange={(e) => {
                                                                            const list = { ...(formData.ListParams || {}) };
                                                                            list[paramKey] = {
                                                                                ...(list[paramKey] || {}),
                                                                                orderBy: e.target.value
                                                                            };
                                                                            setFormData({ ...formData, ListParams: list });
                                                                        }}
                                                                    />
                                                                </td>
                                                            ) : (
                                                                <td></td>
                                                            )}

                                                            {/* ✅ delete button */}
                                                            <td>
                                                                <button
                                                                    type="button"
                                                                    className="text-danger"
                                                                    style={{ background: "none", border: "none" }}
                                                                    onClick={() => handleRemoveParamKey(paramKey)}
                                                                >
                                                                    <i className="icofont-ui-delete" aria-hidden="true"></i>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                )}



                            </div>
                            <div className="modal-footer">
                                <button type="submit" className="btn btn-primary">
                                    <i className="icofont-save" aria-hidden="true"> {currentReport ? " Update" : " Save"}</i>
                                </button>
                                <button className="btn btn-secondary" type="button" data-dismiss="modal" aria-label="Close" onClick={onClose}>
                                    <i className="icofont-close" aria-hidden="true"> Close</i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>

        </div>
    );
}

export default CreateIndustrySector;